const DEFAULT_TIMEZONE = 'America/Toronto';

export default DEFAULT_TIMEZONE;
